import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { LoadingOptions } from '../../../../../models/shared/loading-options';
import { AuthViewModel } from '../../../viewModels/auth-view-model';
import { Router } from '@angular/router';
import { ForgotPasswordRequest } from '../../../../../models/account/requests/forgot-password-request';
import { BsError } from '../../../../../models/shared/bs-error';
import { BaseComponent } from '../../../../../models/base/base-component';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { ReactiveFormEmailComponent } from '@mobilefirstdev/reactive-form';
import { map } from 'rxjs/operators';
import { NavigationService } from '../../../../../services/navigation.service';
import { ToastService } from '../../../../../modules/toasts/service/toast.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss', '../auth.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class ForgotPasswordComponent extends BaseComponent {
  constructor(
    private router: Router,
    private toastService: ToastService,
    public viewModel: AuthViewModel,
    private navigationService: NavigationService
  ) {
    super();
  }

  @ViewChild('resetCodeEmail') resetCodeEmail: ReactiveFormEmailComponent;

  public _loadingOpts = new BehaviorSubject(LoadingOptions.default());
  public loadingOpts$ = this._loadingOpts as Observable<LoadingOptions>;
  public isLoading$ = this._loadingOpts.pipe(map(opts => opts.isLoading));

  public readonly req$ = this.viewModel.preFillEmail$.pipe(map(email => new ForgotPasswordRequest(email)));

  formSubmitted(req: ForgotPasswordRequest) {
    const loadingMess = 'Sending Email';
    if (!this._loadingOpts.containsRequest(loadingMess)) {
      this._loadingOpts.addRequest(loadingMess);
      this.viewModel.forgotPassword$(req).subscribe({
        next: () => this._loadingOpts.removeRequest(loadingMess),
        error: (error: BsError) => {
          this._loadingOpts.removeRequest(loadingMess);
          this.toastService.publishError(error);
          throwError(() => error);
        }
      });
    }
  }

  backToSignIn() {
    const tempEmail = this.resetCodeEmail.getMyValue();
    this.navigationService.signIn({ queryParams: { email: tempEmail } });
  }
}
